import InsightSelect from './InsightSelect';

export default InsightSelect;

export type {
  IInsightSelectOption,
  IInsightSelectProps,
  InsightSelectVariant
} from './InsightSelect';
